<div class="dialog-content-wrapper open-pictures-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    <span class="title dialog-title">{{'main.pictures' | translate}}</span>
    <button mat-button class="mat-icon-button"
      (click)="onNoClick()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>

@if (pictures) {
  <div class="p-24 m-0 content">
    <img class="img-frame" [src]="getImage(pictures[index].src)"/>
    <div class="buttons">
      <button mat-button (click)="previous()" [disabled]="index === 0"><mat-icon>arrow_back</mat-icon></button>
      <button mat-button (click)="next()" [disabled]="index === pictures.length - 1"><mat-icon>arrow_forward</mat-icon></button>
    </div>
  </div>
}
</div>
